import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHome: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="home, house"><path d="M3.75 9L12 2.25L20.25 9V20.25H3.75V9Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconHome;
